import { DateTime } from 'luxon';

import { DateRangeType } from 'application-types';
import { doDateRangesOverlap } from 'lane-shared/helpers/dates';

// A started slot is not selectable, regardless of booking or capacity status.
export function hasSlotStartedToday(
  slot: DateRangeType,
  now: DateTime
): boolean {
  return doDateRangesOverlap(slot, {
    startDate: now.startOf('day').toJSDate(),
    endDate: now.toJSDate(),
  });
}
